import { createSlice } from '@reduxjs/toolkit'

export const KYCRequestReducer = createSlice({
    name: 'kycRequestData',
    initialState: {
        kycRequestData: null,
    },
    reducers: {
        setKycRequestData: (state, action) => {
            state.kycRequestData = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { setKycRequestData } = KYCRequestReducer.actions

export default KYCRequestReducer.reducer